<!--
  File name: Dialog.vue
  Program Description:
    - This component displays a dialog message when a method has been triggered.
    - Depending on the details of the current feature being accessed, the title,
    the items displayed, and the label for the buttons vary.
-->

<template>
  <v-dialog
    v-model="dialog"
    :max-width="dialogWidth"
    :persistent="persistent"
  >
    <v-card tile>
      <v-card-title
        style="font-size: 16px;"
        :class="titleClass"
        :style="{ color: getButtonColor() }"
      >
        {{ title }}
      </v-card-title>
      <v-card-text
        :class="messageClass"
        :style="!messageClass && 'font-weight: bold; font-size: 15px'"
      >
        <template v-if="!!lists">
          <template v-for="(arr, key) in lists">
            <template v-if="arr && arr.length && key !== 'operation'">
              <p
                :key="key"
                class="pt-3"
                :style="`color: ${messageType(key)[1]}`"
              >
                {{ `Items ${messageType(key)[0]} ${lists.operation}d:` }}
              </p>
              <ul :key="key+arr">
                <li
                  v-for="(item, idx) in arr"
                  :key="idx+item"
                >
                  {{ item }}
                </li>
              </ul>
            </template>
          </template>
        </template>
        <template
          v-else
          :style="!messageClass && 'font-size: 14px'"
        >
          {{ message }}
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="!removeCancel"
          id="cancel-btn"
          text
          @click.stop="() => {
            $emit('close')
            dialog = false
          }"
        >
          Cancel
        </v-btn>

        <v-btn
          id="confirm-btn"
          :color="buttonColor"
          :style="`color: ${buttonColor}; font-size: 14px`"
          :class="buttonClass"
          text
          @click="() => {
            callback()
            dialog=false
          }"
        >
          {{ buttonLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    value: Boolean,
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: 'text--darken-2 font-weight-bold'
    },
    message: {
      type: String,
      default: ''
    },
    messageClass: {
      type: String,
      default: ''
    },
    buttonLabel: {
      type: String,
      default: 'Proceed'
    },
    buttonColor: {
      type: String,
      default: '#E53935'
    },
    buttonClass: {
      type: String,
      default: 'text--darken-1 font-weight-bold'
    },
    callback: {
      type: Function,
      default: () => {}
    },
    removeCancel: Boolean,
    dialogWidth: {
      type: String,
      default: '280'
    },
    lists: {
      type: Object,
      default: undefined
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    messageType (key) {
      if (key === 'errors') return ['not', 'red']
      return ['successfully', 'green']
    },
    getButtonColor () {
      switch (this.buttonColor) {
        case 'primary':
          return this.$vuetify.theme.themes.light.primary
        case 'success':
          return '#43A047'
        case 'error':
          return '#E53935'
        default:
          return this.buttonColor
      }
    }
  }
}
</script>
